import React, { useEffect } from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ChangeEventPriorityDialog from '../molecules/ChangeEventPriorityDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  withState('openChange', 'updateOpenChange', false),
  withState('openChangeConfirm', 'updateOpenChangeConfirm', false),
  withState('priority', 'setPriority', props => {
    return props.eventPriority;
  }),
  withState('oldPriority', 'setOldPriority', props => {
    return props.eventPriority;
  })
);

const button = enhance(
  ({
    eventId,
    priority,
    setPriority,
    oldPriority,
    setOldPriority,
    openChange,
    disabled,
    updateOpenChange,
    message,
    setMessage,
    openChangeConfirm,
    updateOpenChangeConfirm,
    eventPriority
  }) => {
    const updateChange = () => {
      updateOpenChange(true);
    };
    useEffect(() => {
      setPriority(eventPriority);
      setOldPriority(eventPriority);
    }, [eventPriority]);
    return (
      <div>
        <Button
          disabled={disabled}
          color="primary"
          onClick={() => updateChange(true)}
        >
          {oldPriority}
        </Button>
        <ChangeEventPriorityDialog
          openChange={openChange}
          updateOpenChange={updateOpenChange}
          target="Change"
          message={message}
          setMessage={setMessage}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
          eventId={eventId}
          priority={priority}
          setPriority={setPriority}
          oldPriority={oldPriority}
          setOldPriority={setOldPriority}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
